import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyModule } from 'src/app/shared/currency/currency.module';
import { OrderByPipe } from 'src/app/shared/pipes/order-by.pipe';
import { GetColumnValuePipe } from 'src/app/shared/table/pipes/get-column-value.pipe';
import { GetCustomTemplatePipe } from 'src/app/shared/table/pipes/get-custom-template.pipe';
import { NumberSuffixPipe } from 'src/app/shared/table/pipes/number-suffix.pipe';
import { NumberWithSpacesPipe } from 'src/app/shared/table/pipes/number-with-space.pipe';
import { TableColumn, TableColumnHeaderType, TableColumnType, TemplatesMap } from './table.types';
import { CdkDragDrop, DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    GetColumnValuePipe,
    GetCustomTemplatePipe,
    NumberSuffixPipe,
    NumberWithSpacesPipe,
    TranslateModule,
    DragDropModule,
    CurrencyModule,
    OrderByPipe,
  ],
})
export class TableComponent<T = any> {
  @Input()
  public customTemplates: TemplatesMap;

  @Input()
  public customHeaderTemplates: TemplatesMap;

  @Input()
  public noDataTemplate: TemplateRef<HTMLElement>;

  @Input()
  public rows: T[];

  @Input()
  public columns: TableColumn[];

  @Input()
  public tableClasses: any;

  @Input()
  public headerClasses: any;

  @Input()
  public rowClassesFn?: (row: T) => any;

  @Input()
  public draggable?: boolean = false;

  @Output()
  public rowDragged = new EventEmitter<{ previousIndex: number, currentIndex: number }>();

  public tableColumnType = TableColumnType;
  public tableColumnHeaderType = TableColumnHeaderType;

  public onDrop(event: CdkDragDrop<T[]>){
    const previousIndex = event.previousIndex;
    const currentIndex = event.currentIndex;
    this.rowDragged.emit({ previousIndex, currentIndex });
  }
}
